/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceInsuranceType(name, id, weight) {
    this.name = name;
    this.id = id;
    this.weight = weight;
  }

  /*
   * Private Methods
   * --------------------------------------------------------------------------------
   */
  function checkAssetFinanceInsuranceType(id) {
    const index = _.findIndex(AssetFinanceInsuranceType.availableTypes, { id });
    return index !== -1;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceInsuranceType.Build = function (data) {
    if (!data || !data.id || !checkAssetFinanceInsuranceType(data.id)) {
      return new AssetFinanceInsuranceType(
        AssetFinanceInsuranceType.default.id.sanitize(),
        AssetFinanceInsuranceType.default.id,
        AssetFinanceInsuranceType.default.weight
      );
    }
    return new AssetFinanceInsuranceType(data.name, data.id, data.weight);
  };

  /*
   * Public Properties
   * --------------------------------------------------------------------------------
   */
  AssetFinanceInsuranceType.default = { id: 'motor_vehicle_insurance', weight: 1 };
  AssetFinanceInsuranceType.availableTypes = [{ id: 'motor_vehicle_insurance', weight: 1 }];
  AssetFinanceInsuranceType.available = _.map(
    AssetFinanceInsuranceType.availableTypes,
    (assetFinanceInsuranceType) =>
      new AssetFinanceInsuranceType(
        assetFinanceInsuranceType.id.sanitize(),
        assetFinanceInsuranceType.id,
        assetFinanceInsuranceType.weight
      )
  );

  /*
   * Public Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceInsuranceType.prototype.getName = function () {
    return this.name;
  };

  return AssetFinanceInsuranceType;
};
